import type { ProductCode } from '@data/config/reports';

export interface ColumnRule {
  /** Column key as returned by metrics-table v2. */
  key: string;
  /** Which ed apps this column applies to. Omit = all ed apps. */
  edApps?: ProductCode[];
}

/**
 * Returns the set of column keys that should be visible for the given ed app.
 * Rules without `edApps` apply to all ed apps.
 */
export function resolveColumnKeys(
  rules: ColumnRule[],
  edApp: ProductCode
): Set<string> {
  return new Set(
    rules
      .filter((rule) => !rule.edApps || rule.edApps.includes(edApp))
      .map((rule) => rule.key)
  );
}
